import React from "react";

import Profile from "./Profile";
import ChangePassword from "./ChangePassword";
import { RoutingTabs } from "../../components/RoutingTabs";
import { APP_ROUTES } from "../../helpers/routeHelpers";
import { Helmet } from "react-helmet";
import { Container } from "reactstrap";
import { PageTitles } from "../../constants";
import { SummaryCard } from "../../components/SummaryCard";

const Account = ({}) => {
    let CONFIG = {
        tabsConfig: [
            {
                title: "Profile",
                id: "1",
                defaultActive: true,
                path: APP_ROUTES.ACCOUNT_PROFILE,
                exact: true,
                component: <Profile />
            },
            {
                title: "Change Password",
                id: "2",
                defaultActive: false,
                path: APP_ROUTES.ACCOUNT_CHANGE_PASSWORD,
                exact: true,
                component: <ChangePassword />
            }
        ]
    };

    return (
        <div className="page-content">
            <Helmet>
                <title>{PageTitles.ACCOUNT}</title>
            </Helmet>
            <Container fluid>
                <SummaryCard>
                    <RoutingTabs
                        config={CONFIG}
                        isPills
                        isTabs={true}
                        parentRoute={APP_ROUTES.ACCOUNT}
                    />
                </SummaryCard>
            </Container>
        </div>
    );
};

export default Account;
